const IOS_STORE_URL = "https://apps.apple.com/app/hynt-homes-made-easy/id6752606030";
const ANDROID_STORE_URL = "https://play.google.com/store/apps/details?id=com.hynt.app";
const FALLBACK_URL = "https://hynt.co.in/";

export const getDevicePlatform = () => {
  if (typeof navigator === "undefined") return "other";
  const userAgent = navigator.userAgent || navigator.vendor || "";

  if (/android/i.test(userAgent)) return "android";
  if (
    /iPad|iPhone|iPod/i.test(userAgent) ||
    /macintosh|mac os intel|mac os arm|mac os x/i.test(userAgent)
  ) {
    return "ios";
  }
  return "other";
};

export const getStoreLinkByDevice = () => {
  const platform = getDevicePlatform();
  if (platform === "ios") return IOS_STORE_URL;
  if (platform === "android") return ANDROID_STORE_URL;
  return ANDROID_STORE_URL;
};

export const openStoreLinkByDevice = (target = "_blank") => {
  const url = getStoreLinkByDevice();
  if (typeof window === "undefined") return url;
  window.open(url, target);
  return url;
};
 export const openAndroidStoreLink = (target = "_blank") => {
  const url = ANDROID_STORE_URL;
  if (typeof window === "undefined") return url;
  window.open(url, target);
  return url;
 };
 export const openIosStoreLink = (target = "_blank") => {
  const url = IOS_STORE_URL;
  if (typeof window === "undefined") return url;
  window.open(url, target);
  return url;
 };

export const STORE_LINKS = {
  ios: IOS_STORE_URL,
  android: ANDROID_STORE_URL,
  fallback: FALLBACK_URL,
};
